(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-list"] && !Shopify.designMode) return;
  try {
    //add an aria label to the checkbox loaded in for the compare function

  document.querySelectorAll('.input-checkbox-label').forEach(function (checkbox) {
    checkbox.setAttribute('aria-label', 'Compare this product');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    //add an aria label to the checkbox loaded in for the compare function
  document.querySelectorAll('.input-checkbox-label').forEach(function (checkbox) {
    checkbox.setAttribute('aria-label', 'Compare this product');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wpt-quiz-product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.input-checkbox-label').forEach(function (checkbox) {
    checkbox.setAttribute('aria-label', 'Compare this product');
  });
  } catch(e) { console.error(e); }
})();

})();
